import * as React from 'react'
import { styled } from 'next-yak'

import * as hooks from '../hooks'

import * as glyphs from '../icons/glyphs'
import * as S from '../styles'

export type ContentToggleProps = {
  children: React.ReactNode
  maxHeight: number
  translations: {
    showMore: string
    showLess: string
  }
}

function ContentToggleComponent({
  children,
  maxHeight,
  translations,
}: ContentToggleProps): React.ReactElement<ContentToggleProps> {
  const [isOpen, setIsOpen] = React.useState(false)
  const [isActive, setIsActive] = React.useState(false)
  const previousActiveState = hooks.usePrevious(isActive)

  const onToggle = (): void => {
    setIsOpen(!isOpen)
  }

  return (
    <S.toggle.ToggleWrapper>
      <S.toggle.ContentWrapper $isActive={isActive} $isToggled={isOpen} $maxHeight={maxHeight}>
        <div
          ref={(node) => {
            if (!node) {
              return
            }
            const contentHeight = node?.offsetHeight
            if (isActive !== previousActiveState) {
              setIsActive(contentHeight > maxHeight)
            }
          }}
        >
          {children}
        </div>
      </S.toggle.ContentWrapper>
      {isActive && (
        <S.toggle.ToggleButton onClick={onToggle} $isToggled={isOpen}>
          {isOpen ? translations.showLess : translations.showMore}
          <glyphs.stroke.CaretDown size={12} />
        </S.toggle.ToggleButton>
      )}
    </S.toggle.ToggleWrapper>
  )
}

export const ContentToggle = styled(ContentToggleComponent)<ContentToggleProps>``
